import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { addExtraReducer } from '../../utils/addExtraReducer';
import {
  CreateTaxReducer,
  DeleteTaxReducer,
  EditTaxReducer,
  GetSingleTaxReducer,
  GetTaxesReducer,
  resetTaxesStateReducer,
} from './reducers';
import { CreateTax, DeleteTax, EditTax, GetSingleTax, GetTaxes } from './thunks';

export const taxesSlice = createSlice({
  name: 'taxes',
  initialState,
  reducers: {
    resetTaxesState: resetTaxesStateReducer,
  },
  extraReducers: (builder) => {
    builder.addCase(GetTaxes.pending, GetTaxesReducer.pending);
    builder.addCase(GetTaxes.fulfilled, GetTaxesReducer.fulfilled);
    builder.addCase(GetTaxes.rejected, GetTaxesReducer.rejected);
    addExtraReducer(builder, CreateTax, CreateTaxReducer);
    addExtraReducer(builder, GetSingleTax, GetSingleTaxReducer);
    addExtraReducer(builder, EditTax, EditTaxReducer);
    addExtraReducer(builder, DeleteTax, DeleteTaxReducer);
  },
});

export default taxesSlice.reducer;
